export const swap = (items: any[], firstIndex, secondIndex): any[] => {
  const results = items.slice();
  const firstItem = items[firstIndex];
  results[firstIndex] = items[secondIndex];
  results[secondIndex] = firstItem;

  return results;
};
